import React from 'react';
import Modal from 'components/Modal';

export default function PaymentFailureMessageModal({ isOpen, onRequestClose, message }) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <div>
        <h3
          className="heading heading--2 heading--inverse"
        >
          Payment failed
        </h3>
        <hr style={{ marginTop: '.25rem' }}/>
        <p>
          {message}
        </p>
      </div>
    </Modal>
  );
}
